export class MstiSectionCode {

    public static readonly ALL_RISK = '5002';
    public static readonly HOME_CONTENTS = '3002';

}
